import type { SVGProps } from 'react';

/**
 * Dashboard-Tile-Grid (4 Kacheln, gestrichelte Outlines).
 * Brand-Akzent: rechts unten ein gefuelltes Tile in Brand-500.
 * Stroke-only, currentColor — Faerbung kommt vom Container.
 */
export function EmptyDashboardIllustration(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <rect
        x="16"
        y="16"
        width="44"
        height="44"
        rx="6"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeDasharray="4 3"
        opacity="0.5"
      />
      <rect
        x="68"
        y="16"
        width="44"
        height="44"
        rx="6"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeDasharray="4 3"
        opacity="0.5"
      />
      <rect
        x="16"
        y="68"
        width="44"
        height="44"
        rx="6"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeDasharray="4 3"
        opacity="0.5"
      />
      <rect
        x="68"
        y="68"
        width="44"
        height="44"
        rx="6"
        className="text-brand-500"
        stroke="currentColor"
        strokeWidth="1.5"
        fill="currentColor"
        fillOpacity="0.12"
      />
      <path
        d="M76 100 L84 92 L90 98 L104 84"
        className="text-brand-500"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
